(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function() {
    var productRecommendationsSection = document.querySelector(".product-recommendations");
    if (productRecommendationsSection === null || productRecommendationsSection.dataset.loaded === "true") { return; }
    productRecommendationsSection.dataset.loaded = "true";
    var request = new XMLHttpRequest();
    request.open("GET", productRecommendationsSection.dataset.url);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        var responseSection = container.querySelector(".product-recommendations");
        if (responseSection) {
          productRecommendationsSection.innerHTML = responseSection.innerHTML;
          if (theme.ProductBlockManager) {
            theme.ProductBlockManager.loadImages(productRecommendationsSection);
          }
          if (theme.initAnimateOnScroll) {
            theme.initAnimateOnScroll();
          }
        }
      }
    };
    request.send();
  };

  var scheduleProductRecommendationsLoad = function() {
    var productRecommendationsSection = document.querySelector(".product-recommendations");
    if (productRecommendationsSection === null) { return; }

    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) {
          loadProductRecommendationsIntoSection();
          observer.disconnect();
        }
      }, { rootMargin: "200px 0px" });
      observer.observe(productRecommendationsSection);
    } else if ("requestIdleCallback" in window) {
      requestIdleCallback(loadProductRecommendationsIntoSection, { timeout: 2000 });
    } else {
      setTimeout(loadProductRecommendationsIntoSection, 1);
    }
  };

  document.addEventListener("shopify:section:load", function(event) {
    if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
      loadProductRecommendationsIntoSection();
    }
  });
  scheduleProductRecommendationsLoad();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function() {
    var productRecommendationsSection = document.querySelector(".related-products");
    if (productRecommendationsSection === null || productRecommendationsSection.dataset.loaded === "true") { return; }
    productRecommendationsSection.dataset.loaded = "true";
    var request = new XMLHttpRequest();
    request.open("GET", productRecommendationsSection.dataset.url);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        var responseSection = container.querySelector(".related-products");
        if (responseSection) {
          productRecommendationsSection.innerHTML = responseSection.innerHTML;
        }
      }
    };
    request.send();
  };

  var scheduleProductRecommendationsLoad = function() {
    var productRecommendationsSection = document.querySelector(".related-products");
    if (productRecommendationsSection === null) { return; }

    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) {
          loadProductRecommendationsIntoSection();
          observer.disconnect();
        }
      }, { rootMargin: "200px 0px" });
      observer.observe(productRecommendationsSection);
    } else if ("requestIdleCallback" in window) {
      requestIdleCallback(loadProductRecommendationsIntoSection, { timeout: 2000 });
    } else {
      setTimeout(loadProductRecommendationsIntoSection, 1);
    }
  };

  document.addEventListener("shopify:section:load", function(event) {
    if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
      loadProductRecommendationsIntoSection();
    }
  });
  scheduleProductRecommendationsLoad();

  } catch(e) { console.error(e); }
})();
})();
